<template>
  <section class="resume-section p-3 p-lg-5 d-flex justify-content-center" id="portfolio">
    <div class="w-100">
        <h2 class="mb-5">Portfolio</h2>

        <div class="resume-item d-flex flex-column flex-md-row justify-content-between mb-5" v-for="pfolio in portfolio" :key="pfolio">
          <div class="resume-content">
            <h3 class="mb-0">{{ pfolio.title }}</h3>
            <div class="mb-3">
              <ul class="list-inline">
                <li class="list-inline-item" v-for="tech in pfolio.technologies" :key="tech"><strong>{{ tech }}</strong> | </li>
              </ul>
            </div>
            <p class="lead">{{ pfolio.description }}</p>
          </div>
          <div class="resume-date text-md-right">
            <span class="text-primary">{{ pfolio.year }}</span>
          </div>
        </div>
    </div>
  </section>
</template>

<script type="ts">
export default {
  data () {
    return {
      portfolio: [
        {
          title: 'Patrol Platform & API',
          year: '2019',
          description: 'Patrol Platform to Register and Monitor Security Employee. External REST API for mobile app.',
          technologies: [
            'Bootstrap',
            'Symfony',
            'MySQL',
            'REST API'
          ]
        },
        {
          title: 'Professional Technical College Frontend',
          year: '2018',
          description: 'Educational project to manage students access & egress, evaluations, students profile, and parents traceability. Frontend.',
          technologies: [
            'Angular',
            'Bootstrap'
          ]
        },
        {
          title: 'Profesional Technical College Backend & Daemon',
          year: '2018',
          description: 'Educational project to manage students access & egress, evaluations, students profile, and parents traceability. Backend & Daemon.',
          technologies: [
            'Symfony',
            'MySQL',
            'Microservices',
            'REST API'
          ]
        },
        {
          title: 'Credits Management System',
          year: '2017',
          description: 'Credits list, borrowed credits, late payments.',
          technologies: [
            'Bootstrap',
            'Symfony',
            'MySQL'
          ]
        },
        {
          title: 'Access Control & Sentinel',
          year: '2016',
          description: 'Access Control, Monitors access & egress, parking management, black lists.',
          technologies: [
            'Bootstrap',
            'Symfony',
            'MySQL',
            'ElasticShearch'
          ]
        },
        {
          title: 'Human Resources Manager & Payments',
          year: '2015',
          description: 'Employees Manager, Personnel Actions and Payrolls.',
          technologies: [
            'Bootstrap',
            'Symfony',
            'MySQL'
          ]
        },
        {
          title: 'Caribbean Points of Interest',
          year: '2014',
          description: 'Website with Caribbean points of interests.',
          technologies: [
            'Bootstrap',
            'Symfony',
            'MySQL'
          ]
        },
        {
          title: 'Buses Workshop, Storage & Resources Manager',
          year: '2014',
          description: 'Buses Manager, Workshop and orders monitor. Reception, inventory, inputs and outputs of materials from Storage.',
          technologies: [
            'Bootstrap',
            'Symfony',
            'MySQL'
          ]
        },
        {
          title: 'Buses Incomes Management System',
          year: '2013',
          description: 'Buses daily incomes, checkouts, debts and reports.',
          technologies: [
            'Bootstrap',
            'Symfony',
            'MySQL'
          ]
        },
        {
          title: 'Monitoring and Analysis System',
          year: '2013',
          description: 'Web analytics and crawling, using metrics and data generated by web sites.',
          technologies: [
            'Bootstrap',
            'Symfony',
            'PostgreSQL'
          ]
        },
        {
          title: 'Organizational and Content Manager System',
          year: '2012',
          description: 'Content Management System focused on organizations structured processes.',
          technologies: [
            'Bootstrap',
            'Symfony',
            'PostgreSQL'
          ]
        },
        {
          title: 'Logs Analysis and Informations System',
          year: '2012',
          description: 'System based on bulk logs analysis and search indexed data.',
          technologies: [
            'Bootstrap',
            'Symfony',
            'PostgreSQL',
            'Syslogs'
          ]
        }
      ]
    }
  }
}
</script>
